import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { marketPeriodHelper } from "app/helpers/marketPeriodHelper";
import type {
  EventMarketType,
  EventRunnerType,
  EventType,
} from "app/types/eventType";
import groupBy from "lodash/groupBy";
import { Component } from "react";
import { connect } from "react-redux";
import RenderOddsComponent from "../RenderOddsComponent/RenderOddsComponent";
import "./ThreewayMarketRunnerDetailsAlt.scss";
type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: Record<string, any>;
  addBetSlip: (...args: Array<any>) => any;
  columnType: string;
}; //

class ThreewayMarketRunnerDetailsAlt extends Component<Props> {
  addBetSlip = (runner: EventRunnerType) => {
    let betSlip = BetSlipHelper.prepareBetSlip(this.props.event, runner);
    this.props.addBetSlip(betSlip);
  };
  renderOdds = (runners: Array<any>) => {
    const odds: JSX.Element[] = [];
    runners.forEach(runner => {
      if (marketPeriodHelper.shouldHideRunner(runner)) {
        return (
          <span
            key={"threeway" + runner.id}
            className="threeway-alt__runner--empty"
          ></span>
        );
      }
      const runnerEl = (
        <span
          key={"threeway" + runner.id}
          onClick={() => {
            this.addBetSlip(runner);
          }}
          className={"threeway-alt__runner"}
        >
          <div className="runner__name">{runner.name}</div>
          <RenderOddsComponent event={this.props.event} runner={runner} />
        </span>
      );
      odds.push(runnerEl);
    });
    return odds;
  };

  getColumn = (side: string, groupedRunners: Record<string, any>) => {
    const hasSide = side in groupedRunners;

    const randomNumber = Math.floor(Math.random() * 1000) + 1;
    if (hasSide) {
      return (
        <div
          key={`${this.props.market.id}-${side.toLowerCase()}--${randomNumber}`}
          className="threeway-alt__column"
        >
          {this.renderOdds(groupedRunners[side])}
        </div>
      );
    } else {
      return (
        <div
          key={`${this.props.market.id}-${side.toLowerCase()}--${randomNumber}`}
          className="threeway-alt__column--placeholder"
        ></div>
      );
    }
  };

  renderColumns = (groupedRunners: Record<string, any>) => {
    // Order columns based on marketType
    // WINNING_MARGIN: HOME, DRAW, AWAY
    // FIRST_LAST_GOAL: FIRST_GOAL, LAST_GOAL, NO_GOAL
    // GOALSCORER: HOME, AWAY, NA

    const columns: JSX.Element[] = [];
    let marketTypeName = this.props.marketType.marketType;

    if (
      marketTypeName.includes("GOALSCORER") ||
      marketTypeName.includes("TOUCHDOWN_SCORER")
    ) {
      marketTypeName = "GOALSCORER";
    }

    switch (marketTypeName) {
      case "WINNING_MARGIN":
        if (this.props.event.showHomePlayerAsFirst) {
          columns.push(this.getColumn("HOME", groupedRunners));
          columns.push(this.getColumn("DRAW", groupedRunners));
          columns.push(this.getColumn("AWAY", groupedRunners));
        } else {
          columns.push(this.getColumn("AWAY", groupedRunners));
          columns.push(this.getColumn("DRAW", groupedRunners));
          columns.push(this.getColumn("HOME", groupedRunners));
        }

        break;

      case "FIRST_LAST_GOAL":
        columns.push(this.getColumn("FIRST_GOAL", groupedRunners));
        columns.push(this.getColumn("LAST_GOAL", groupedRunners));
        columns.push(this.getColumn("NO_GOAL", groupedRunners));
        break;
      case "GOALSCORER":
        columns.push(this.getColumn("HOME", groupedRunners));
        columns.push(this.getColumn("AWAY", groupedRunners));
        columns.push(this.getColumn("NA", groupedRunners));
        break;

      default:
        break;
    }

    return columns;
  };

  render() {
    const { market, marketType, columnType } = this.props;
    const groupedRunners = groupBy(market.runners, columnType);
    return (
      <div
        className={`${marketType.marketType.toLowerCase()} market threeway threeway-alt`}
      >
        {this.renderColumns(groupedRunners)}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(ThreewayMarketRunnerDetailsAlt) as any;
